module.exports = {
  urlPrefix: '/home/',
  debug: false,
};

//  ffmpeg -i slide05.mp4 -profile:v baseline -level 3.0 slide05-2.mp4
